const abg = {
  name: 'ABG Systems',
  sidebarLogo: '/brand/abgsystems-white.png',
  loginLogo: '/brand/abgsystems-white.png',
  mobileLoginLogo: '/brand/abgsystems-white.png',
  darkPanel: true,
};

const facilities = {
  name: 'Facilities Solutions',
  sidebarLogo: '/brand/facilities-solutions-logo.png',
  loginLogo: '/brand/facilities-solutions-logo-alt.png',
  mobileLoginLogo: '/brand/facilities-solutions-logo.png',
  darkPanel: false,
};

// Select at runtime so the same release artifact can be promoted from QA to PROD.
export function getPortalBrand(hostname = window.location.hostname) {
  return hostname === 'platform.facilitiessolutions.io' ? facilities : abg;
}
